import React from "react";
import {
    Button, checkAndSetError, clearInputFormErrorFields,
    convertInputFormToObject,
    InputForm,
    inputFormIsValid, NumberField,
    TextField,
    DateTimePickerField,
    useInputForm
} from "../../../../Components/Inputs";
import {aphCatalogItemModel} from "./aphCatalogItemFactory";
import {GridCell, gridConstants} from "../../../../Components/Grid";

interface AphCatalogItemViewProps {
    handleSaveAphCatalogItem: (data: Record<string, unknown>) => void;
    handleReturn: () => void;
    aphCatalogItem: Record<string, any>;
}

export const AphCatalogItemView = ({
                                    handleSaveAphCatalogItem,
                                    handleReturn,
                                    aphCatalogItem,
                                }: AphCatalogItemViewProps) => {

    const aphCatalogItemForm = useInputForm(aphCatalogItemModel(aphCatalogItem));

    const handleSubmitClick = () => {

        clearInputFormErrorFields(aphCatalogItemForm);

        checkAndSetError([
            aphCatalogItemForm.catalogNumber,
            aphCatalogItemForm.title,
            aphCatalogItemForm.cost
            ]);

        if (inputFormIsValid(aphCatalogItemForm)) {
            const convertedFormData = convertInputFormToObject(aphCatalogItemForm);
            const aphCatalogItem = aphCatalogItemModel(convertedFormData);
            handleSaveAphCatalogItem(aphCatalogItem);
        }
    }

    return <>
        <InputForm name={`aphCatalogItemForm`}>
            <TextField {...aphCatalogItemForm.catalogNumber} medium_columns={gridConstants.column.SIX}/>
            <TextField {...aphCatalogItemForm.title} medium_columns={gridConstants.column.SIX}/>
            <NumberField {...aphCatalogItemForm.cost} isPositiveNumberOnly medium_columns={gridConstants.column.SIX}/>
            
            <GridCell medium_columns={gridConstants.column.TWELVE}>
                <h3>What&apos;s New Settings</h3>
            </GridCell>
            <DateTimePickerField {...aphCatalogItemForm.whatsNewStartDate} medium_columns={gridConstants.column.SIX}/>
            <DateTimePickerField {...aphCatalogItemForm.whatsNewEndDate} medium_columns={gridConstants.column.SIX}/>

            <hr/>
            <GridCell className={`text-center`}>
                <Button isPrimary isCollapsed label={'Save'} name={`btnSubmit`}
                        onClick={handleSubmitClick}/>
                <Button isCollapsed label={'Cancel'} name={`btnCancel`} onClick={handleReturn}/>
            </GridCell>
        </InputForm>
    </>;
};
